import request from '@/utils/request';

export function orderInfos(params) {
  return request({
    url: '/api/guarantee',
    method: 'get',
    headers: {
      'Cache-control': 'no-cache',
      Pragma: 'no-cache',
    },
    params,
  });
}

export function cetRandom(params) {
  return request({
    url: '/api/accCertification/cetRandom',
    method: 'get',
    params,
  });
}
export function certVerify(params) {
  return request({
    url: '/api/accCertification/certVerify',
    method: 'post',
    params,
  });
}
export function orderInfoGive(params) {
  return request({
    url: '/orderInfoApi/orderInfoGive',
    method: 'post',
    params,
  });
}
export function getOrderInfos(params) {
  return request({
    url: '/api/guarantee',
    method: 'get',
    params,
  });
}
export function getCenterApplyInfos(params) {
  return request({
    url: '/api/insure/index/center/orderInfos',
    method: 'get',
    params,
  });
}
export function getApplyInfos(params) {
  return request({
    url: '/api/apply/orderInfos',
    method: 'get',
    params,
  });
}
export default { orderInfos, cetRandom, certVerify, orderInfoGive ,getOrderInfos,getApplyInfos};
